import React from 'react';
import { CustomRoleType } from './custom-roles.types';
import { getColorsForRole, getTextForSystemRole } from './utils';
import clsx from 'clsx';

interface RoleTagProps extends Pick<CustomRoleType, 'color' | 'name'> {
  className?: string;
}

const RoleTag = ({ name, color, className }: RoleTagProps) => {
  const { backgroundColor, color: textColor } = getColorsForRole(name, color);

  if (!name) return null;

  return (
    <div
      className={clsx(
        'flex h-6 items-center justify-center whitespace-nowrap rounded-lg px-2 text-xs font-bold',
        textColor,
        className,
      )}
      style={{ backgroundColor }}
    >
      {getTextForSystemRole(name)}
    </div>
  );
};

export default RoleTag;
